import React from 'react';
import AdvisoryAppShell from './AdvisoryAppShell';
import AdvisoryFlowFriendlyError from './AdvisoryFlowFriendlyError';

interface Props {
  error?: unknown;
}

const AdvisoryFlowError = ({ error }: Props) => {
  return (
    <AdvisoryAppShell>
      <AdvisoryFlowFriendlyError error={error} />
    </AdvisoryAppShell>
  );
};

export default AdvisoryFlowError;
